interface ProductImageProps {
  name: string
  url: string
  imageUrl?: string
  imageLoading?: 'lazy' | 'eager'
}

const PLACEHOLDER_IMAGE = '/media/catalog/product/placeholder/default/placeholder.jpg'

/**
 * ProductImage - Static product image (no hover swap, no zoom).
 *
 * Compact sizing: h-[150px] xl:h-[200px].
 */
export function ProductImage({
  name,
  url,
  imageUrl,
  imageLoading = 'lazy',
}: ProductImageProps) {
  const displayImage = imageUrl || PLACEHOLDER_IMAGE

  return (
    <a
      href={url}
      title={name}
      className="relative row-span-1 h-[150px] xl:h-[200px] flex justify-center items-center overflow-hidden"
    >
      <img
        src={displayImage}
        alt={name}
        width={300}
        height={300}
        loading={imageLoading}
        className="w-5/6 xl:w-4/5 object-contain object-center max-h-[150px] xl:max-h-[190px] text-sm"
      />
    </a>
  )
}
